import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "application-component" }
const _hoisted_2 = { class: "application-component-title" }
const _hoisted_3 = { class: "module-status" }
const _hoisted_4 = { class: "module-card" }
const _hoisted_5 = { class: "module-card-label" }
const _hoisted_6 = { class: "module-card-title" }
const _hoisted_7 = { class: "module-card-description" }
const _hoisted_8 = {
  key: 0,
  class: "module-preview textselection"
}

import { useGlobalStore } from '@/store/modules/global'


export default {
  __name: 'PendingModule',
  props: {
  readOnly: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => null,
  },
  application: {
    type: Object,
    default: () => null,
  },
},
  setup(__props) {

const globalStore = useGlobalStore()



const fontSize = computed(() => `${globalStore.fontSize}px`)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.application?.name || '模块占位'), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.application?.moduleStatus || '新增'), 1)
    ]),
    _createElementVNode("div", {
      class: "application-component-content",
      style: _normalizeStyle({ fontSize: _unref(fontSize) })
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.application?.type || '模块'), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.application?.name || '模块说明'), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(__props.application?.description || '当前模块入口已接入，功能将在后续逐个实现。'), 1)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "module-state" }, " 当前已完成组件入口接入和页面占位，数据生成、交互编辑和导出能力将在后续开发中逐个补齐。 ", -1)),
      (__props.data?.docResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.data.docResult), 1))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

}